import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";

import {
  getValueType,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  selectParameter,
  selectParameter2,
  selectParameter3,
} from "../businessParameter/businessParameterSlice";
import {
  FormControlLabel,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";

import { ModalAreaSelect } from "./ModalAreaSelect";

import {
  selectIdLocation,
  selectLoading,
  fetchIdLocation,
  editLocation,
  addLocation,
} from "./locationManagementSlice";
import {
  fetchMstareatype,
  selectMstareatype,
} from "../motorPool/motorPoolSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});
function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const MotorPoolEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdLocation);
  const { id } = useParams();
  const dataDistance = useSelector(selectParameter);
  const dataAreaType = useSelector(selectMstareatype);

  // initial

  const [formValues, setFormValues] = useState({
    name: {
      value: "",
      error: false,
      required: "Y",
    },
    length: {
      value: "",
      error: false,
      required: "N",
    },
    width: {
      value: "",
      error: false,
      required: "N",
    },
    distance: {
      value: "",
      error: false,
      required: "N",
    },
  });

  const [formArea, setFormArea] = useState({
    name: {
      value: "",
      error: false,
      required: "Y",
    },
    area_type: {
      value: "",
      error: false,
      required: "N",
    },
    area_type_name: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      await callApi(id);
      await dispatch(
        fetchParameter({
          paramgroup_code: "DISTANCE_MEASUREMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchMstareatype({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch, id]);

  const callApi = async (id) => {
    try {
      const response = await dispatch(fetchIdLocation(id));
      if (response.payload.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        name: {
          value: dataId.location_name,
          error: false,
          required: "Y",
        },
        length: {
          value: dataId.length,
          error: false,
          required: "N",
        },
        width: {
          value: dataId.width,
          error: false,
          required: "N",
        },
        distance: {
          value: dataId.measurement,
          error: false,
          required: "N",
        },
      });
    }
  }, [dataId]);

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    if (
      formValues.name.value.includes("<script>") ||
      formValues.name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    const params = {
      location_id: dataId.location_id,
      location_name: formValues.name.value,
      length: formValues.length.value,
      width: formValues.width.value,
      measurement: formValues.distance.value,
      type: "motor_pool",
    };

    console.log(params, "params");

    try {
      const response = await dispatch(editLocation(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await callApi(id);
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  // Modal Create
  const [show, setShow] = useState(false);
  const [showArea, setShowArea] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const distanceOptions = dataDistance.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeDistance = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["distance"]: {
        ...formValues["distance"],
        value,
      },
    });
  };

  const areaTypeOptions = dataAreaType.map((e) => {
    return {
      value: e.areatype_id,
      label: e.areatype_code,
    };
  });

  const index = areaTypeOptions.findIndex(
    (obj) => obj.value === formArea.area_type.value
  );

  const handleChangeAreaType = (e) => {
    const value = e.value;
    setFormValues({
      ...formValues,
      ["area_type"]: {
        ...formValues["area_type"],
        value,
      },
    });
  };
  const handleChangeArea = (e) => {
    const { name, value } = e.target;
    setFormArea({
      ...formArea,
      [name]: {
        ...formArea[name],
        value,
      },
    });
  };

  const validatePostArea = (e) => {
    let isValid = true;

    const formFields = Object.keys(formArea);
    let newFormValues = { ...formArea };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formArea[currentField].value;
      const required = formArea[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormArea(newFormValues);

    return isValid;
  };

  const handleSaveArea = async () => {
    if (!validatePostArea()) {
      return;
    }

    const params = {
      pid: dataId.location_id,
      location_name: formArea.name.value,
      area_type: formArea.area_type.value,
      type: "area",
    };

    console.log(params, "params");

    try {
      const response = await dispatch(addLocation(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed)
          await history.push(
            `/motor-pool/location-management/area/${response.payload.data.data.location_id}`
          );
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [fieldsArea, setFieldsArea] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && dataDistance && (
        <>
          <Card>
            <CardBody>
              <ThemeProvider theme={formLabelsTheme}>
                <div className="d-flex justify-content-between">
                  <p className=" font-size-h3 text-title-primary font-weight-boldest">
                    Motor Pool Area : {dataId.location_name}
                  </p>
                  <Button
                    className="my-btn-primary-dark d-flex justify-content-end"
                    onClick={() => setShow(true)}
                  >
                    Create Area
                  </Button>
                </div>

                <div>
                  <Row>
                    <Col xs={12} sm={3} md={6} lg={6}>
                      <RedditTextField
                        // required
                        label="Name"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="name"
                        value={formValues.name.value}
                        onChange={handleChange}
                        error={formValues.name.error}
                        helperText={
                          formValues.name.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} sm={3} md={6} lg={6} className="pr-0">
                      <div className="border-motor-pool">
                        <p className="text-muted">Size</p>
                        <Row>
                          <Col xs={12} sm={4} md={4} lg={4}>
                            <RedditTextField
                              label="Length"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              type="number"
                              name="length"
                              value={formValues.length.value}
                              onChange={handleChange}
                            />
                          </Col>
                          <p className="font-weight-boldest ml-4 mt-7">X</p>
                          <Col xs={12} sm={4} md={4} lg={4}>
                            <RedditTextField
                              label="Width"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              type="number"
                              name="width"
                              value={formValues.width.value}
                              onChange={handleChange}
                            />
                          </Col>
                          <p className="font-weight-boldest ml-4 mt-7">X</p>
                          <Col xs={12} sm={3} md={3} lg={3}>
                            <Select
                              options={distanceOptions}
                              value={getValueType(
                                formValues.distance.value,
                                distanceOptions
                              )}
                              onChange={handleChangeDistance}
                              className="mt-4 ml-3"
                            />
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                  <Row className="mt-6 justify-content-end">
                    <Button variant="primary" onClick={handleSave}>
                      Save
                    </Button>
                  </Row>
                </div>
              </ThemeProvider>

              {/* handleSave */}
            </CardBody>
          </Card>
          {/* Modal Create */}
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={show}
            onHide={handleClose}
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter text-white">
                Create New Area
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <ThemeProvider theme={formLabelsTheme}>
                <div>
                  <Row>
                    <Col xs={12} sm={3} md={6} lg={6}>
                      <RedditTextField
                        required
                        label="Parent Area"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="name"
                        disabled
                        value={dataId.location_name}
                      />
                      <RedditTextField
                        required
                        label="Motor pool Area"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="product_length"
                        value={dataId.location_name}
                        disabled
                      />
                    </Col>

                    <Col xs={12} sm={3} md={6} lg={6}>
                      <RedditTextField
                        required
                        label="Name"
                        className={classes.margin}
                        variant="filled"
                        id="reddit-input"
                        size="small"
                        fullWidth
                        name="name"
                        value={formArea.name.value}
                        onChange={handleChangeArea}
                        error={formArea.name.error}
                        helperText={
                          formArea.name.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {iconError} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                      <Row>
                        <Col xs={10} sm={3} md={9} lg={9}>
                          <RedditTextField
                            label="Area type"
                            className={classes.margin}
                            variant="filled"
                            id="reddit-input"
                            size="small"
                            fullWidth
                            name="area_type"
                            readOnly
                            value={formArea.area_type_name.value}
                            error={formArea.area_type.error}
                            helperText={
                              formArea.area_type.error ? (
                                <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                  {iconError} {"This field is required"}
                                </FormHelperText>
                              ) : (
                                ""
                              )
                            }
                          />
                        </Col>
                        <Col>
                          <div>
                            <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                              <span
                                className="svg-icon svg-icon-md svg-icon-light"
                                onClick={() => setShowArea(true)}
                              >
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/New/Search.svg"
                                  )}
                                />
                              </span>
                            </a>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </ThemeProvider>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" onClick={handleSaveArea}>
                Save
              </Button>
            </Modal.Footer>
          </Modal>

          <ModalAreaSelect
            isOpen={showArea}
            setShow={setShowArea}
            setFormValues={setFormArea}
            formValues={formArea}
            setFields={setFieldsArea}
            fields={fieldsArea}
          />
        </>
      )}
    </>
  );
};
